module.exports = __webpack_public_path__ + "img/contracts-and-terms.2c8fbbd3.svg";